import { render } from "./BudgetStep.vue?vue&type=template&id=6da9825d"
import script from "./BudgetStep.vue?vue&type=script&lang=js"
export * from "./BudgetStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__